module.exports = __webpack_public_path__ + "img/slide-3__md.967c6c30.jpg";